import { ref } from 'vue';
const score = ref(100);
const reports = ref([])
const email = ref('');
export default  {
  score,
  reports,
  email
}